const IGNORED_FILTER_KEYS = new Set([
  'page',
  'pageSize',
  'orderColumn',
  'orderDirection',
  'order',
  'sort',
  'sortColumn',
  'sortDirection',
]);

function normalizeFilterValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    const cleaned = value
      .filter((v) => v !== null && v !== undefined && v !== '')
      .map(normalizeFilterValue);
    const deduped = Array.from(
      new Set(cleaned.map((v) => JSON.stringify(v))),
    ).map((s) => JSON.parse(s) as unknown);

    return deduped.sort((a, b) =>
      JSON.stringify(a).localeCompare(JSON.stringify(b)),
    );
  }

  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};

    for (const key of Object.keys(value as Record<string, unknown>).sort()) {
      if (IGNORED_FILTER_KEYS.has(key)) {
        continue;
      }

      const normalized = normalizeFilterValue(
        (value as Record<string, unknown>)[key],
      );

      if (
        normalized === null ||
        normalized === undefined ||
        normalized === '' ||
        (Array.isArray(normalized) && normalized.length === 0)
      ) {
        continue;
      }

      out[key] = normalized;
    }

    return out;
  }

  return value;
}

/**
 * Builds a deterministic id for a wire filter set. Identical effective filters
 * produce identical ids regardless of key order, pagination, or empty values.
 * @param filters - Raw list-search filters from the client or API.
 * @returns Canonical JSON string used as a list subscription group id.
 */
export function buildFilterGroupId(filters: Record<string, unknown>): string {
  return JSON.stringify(normalizeFilterValue(filters ?? {}));
}
